<template>
  <div>
    <cmSubTopNav :title="unitName" :cb="transToHomePage" :text="'退出'"></cmSubTopNav>
    <div class="page-wrapper">
      <resultBlock :unitName="unitName" :result="result" :vresult="vresult"></resultBlock>
      <ul class="cm-container chapter-type text-center">
        <li class="type-button pointer-no-select" :class="{'active': type === 1}" @click="changeQType(1)">不认识</li>
        <li class="type-button pointer-no-select" :class="{'active': type === 2}" @click="changeQType(2)">认识</li>
      </ul>
      <div class="cm-container chapter-card">
        <div class="action-group">
            <div class="page-wrapper">
            <div class="cm-container" v-if="type===1">
              <wordsList :wdata="wrongdata" :actions="false"></wordsList>
            </div>
            <div class="cm-container" v-else>
              <wordsList :wdata="correctdata" :actions="false"></wordsList>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed-box" @mouseenter="fixedBox = true" @mouseleave="fixedBox = false"></div>
    <div class="fixed-content" v-show="fixedBox"></div>
  </div>
</template>
<script>
import cmSubTopNav from "../../components/cmSubTopNav.vue";
import resultBlock from "../../components/result.vue";
import Storage from "../../service/storage";
import wordsList from "../../components/wordsList.vue";
export default {
  name: 'cmWordsResultPage',
  components: {
    cmSubTopNav,
    resultBlock,
    wordsList
  },
  data(){
    return {
      unitName: '',
      result: {},
      currentGradeInfo: {},
      units: [],
      type: 1,
      correctdata: [],
      wrongdata: [],
      vresult: true,
      fixedBox: false
    }
  },
  created(){
    let result = Storage.get('vocabularyTestResult');
    if (result) {
      this.unitName = result.unitName;
      this.result = result.meta;
      this.result.spanTime = result.spanTime;
      this.correctdata = result.correct_vocabs;
      this.wrongdata = result.wrong_vocabs;
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    transToHomePage(){
      this.$router.push(`/vocabulary`);
    },
    changeQType(data){
      if (data !== this.type) {
        this.type = data;
        // this.loadListData();
      }
    }
  }
}
</script>
